<template>
  <div :class="{'client-action-handler': actionButton}">
    <div
      class="d-flex flex-column align-items-center bl-color w-inline-block no-decoration pointer"
      @click="openClientPersonalInfoPopup()"
      v-if="iconButton"
    >
      <app-icon name="edit" :size="22" />
      upraviť
    </div>
    <div class="div-block-25" v-else>
      <div
        data-w-id="239b29db-b0c5-1e0a-548a-17a023868560"
        class="add-prijem-btn"
        :class="{'client-action-button': actionButton}"
        role="button"
        tabindex="0"
        @click="openClientPersonalInfoPopup()"
        @keydown.enter.space.prevent="openClientPersonalInfoPopup()"
      >
        <div
          class="text-small bl-color pointer"
          :class="{'client-action-label': actionButton}"
        >
          {{ actionLabel || 'upraviť ÚDAJE A BONITU' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "ClientPersonalInfoHandler",
  components: {AppIcon},
  props: {
    clientInfo: [Object, null],
    clientProfile: [Object, null],
    rules: Array,
    iconButton: Boolean,
    mortgageContext: Boolean,
    actionButton: Boolean,
    actionLabel: String,
  },
  methods: {
    openClientPersonalInfoPopup () {
      this.$store.commit("popupManagerState/setClientInfo", {type: this.clientInfo?.type, id: this.clientInfo?.id});
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: {
          clientInfo: this.clientInfo,
          clientProfile: this.clientProfile,
          mortgageContext: this.mortgageContext,
        },
        component: "ClientPersonalInfoPopUp",
        rules: this.rules,
      });
    }
  }
}
</script>

<style scoped>
.app-icon {
  margin-bottom: 3px;
}
</style>
